import createApiUrlProvider from 'utils/apiUrlProvider';
import env from 'utils/env';
const apiUrlProviderEvent = createApiUrlProvider();

export const GET_EVENTS = 'GET_EVENTS';

apiUrlProviderEvent.setBaseUrl(`${env.get('TERMINAL_URL')}/`);
apiUrlProviderEvent.set(GET_EVENTS, '/events/:tid');

export default apiUrlProviderEvent;
